import { render, staticRenderFns } from "./PbcTabButton.vue?vue&type=template&id=38df01c9&"
import script from "./PbcTabButton.vue?vue&type=script&lang=js&"
export * from "./PbcTabButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports